module.exports = __webpack_public_path__ + "static/media/AD_mode15.5c41afd1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/AD_mode15.gif
// module id = 773
// module chunks = 114